var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _ellipse2, _rect2, _rect3, _path17, _path18, _rect4, _rect5, _rect6, _path19, _path20, _path21, _path22, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle, _circle2, _path45, _circle3, _circle4, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect7, _path85, _circle5, _circle6, _circle7, _rect8, _path86, _path87, _circle8, _path88, _rect9, _path89, _path90, _path91, _path92, _path93, _rect10, _rect11, _rect12, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _ellipse3, _path101, _path102, _path103, _path104, _rect13, _rect14, _rect15, _polygon8, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _polygon9, _circle9, _path112, _circle10, _rect16, _circle11, _path113, _path114, _circle12, _circle13, _path115, _circle14, _path116, _path117, _circle15, _circle16, _path118, _path119, _path120;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4680 3120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": 1,
    fill: "#000000",
    className: "color000 svgShape"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4680,
    height: 3120,
    fill: "#ffffff",
    "data-name": 1,
    opacity: 0,
    className: "colorfff svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f7",
    d: "M3930.92,2329.25c-27.39,86.3-88,160.88-168.15,222.47-252,193.71-697,258.88-907.56,155.59-215.53-105.72-392.45-78.24-934.44,22.72-390,72.65-840.62,13.22-1076.48-178.31-91.88-74.61-151.18-169.28-161.6-284-22.2-244.26,126-386.25,257.15-465.12,54.62-35,116.68-64.26,184.48-85.51,301.87-94.59-248.45-297-56.92-913.29,163.23-525.18,776.65-569.94,1100.11-210,161.4,179.6,369.63,283.4,951.5,35.57,525.95-224,837.6,322.07,634.88,731.76s0,435.05,152,697.59C3968.67,2167.2,3961.26,2258.93,3930.92,2329.25Z",
    className: "colorf5f5f7 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#419786",
    d: "M3654.15,2340.94s71-42.57,123.15-100.68,155.14-153.88,210.79-177.18c18.95,52.07,46.19,113.24-14.21,177.18s-91.18,48.41-123.15,107.71-66.62,96.48-117.54,122.61H3544Z",
    className: "color419786 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6fc183",
    d: "M3934.21,2124.69c-10.65,23.78-15.82,64.62-35.52,81.82-52.41,45.74-144.35,60.43-173.29,83.06h0a491.11,491.11,0,0,0,51.9-49.31c52.11-58.12,155.14-153.88,210.79-177.18C3968.54,2073.05,3944.87,2100.91,3934.21,2124.69Z",
    className: "color6fc183 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 3.31,
    d: "M3971.52,2095.43c-22.21,23.65-41.75,100.18-80.83,144.83s-51.51,52.94-97.69,82.33-127,97-148.33,148Z",
    className: "colorStroke292929 svgStroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#419786",
    d: "M3626.91,1833.4s-22.2,47.49-30.2,117c-7.41,64.44,3.55,77.48-10.66,150.58s-27.23,94-42,179.28-25.46,190.3-25.46,190.3H3378.73s10.75-28.14,12.23-97.48-9.57-159.08,14.6-245.37S3491.91,1880.13,3626.91,1833.4Z",
    className: "color419786 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 3.31,
    d: "M3582.5,1878.63s-74.6,71.73-90.59,178.32-1.78,306.1-16,359.87Z",
    className: "colorStroke292929 svgStroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6fc183",
    d: "M3928.88,1857.64s-66.31,22-110.13,27-97.1,10-124.34,36.18-27.24,89.44-63.95,109.54-100.66,83.74-122,134.84S3474.15,2314.81,3473,2354s-23.68,98.49-34.34,116.58H3576s99.47-84.42,125.53-150.75,18.94-137.69,46.18-176.88,75.57-91.75,113.68-138.76C3913.49,1939.93,3928.88,1857.64,3928.88,1857.64Z",
    className: "color6fc183 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 3.31,
    d: "M3883.88,1889.68c-45,35.18-99.47,58.09-137.36,98.39S3658.07,2111,3626.91,2168.2c-56.6,103.9-98.29,254.14-135,302.38Z",
    className: "colorStroke292929 svgStroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#419786",
    d: "M1025.85,2341.21s-71-42.57-123.15-100.68-155.14-153.88-210.79-177.18c-18.95,52.07-46.19,113.24,14.21,177.18s91.18,48.41,123.15,107.71,66.62,96.48,117.54,122.61H1136Z",
    className: "color419786 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6fc183",
    d: "M745.79,2125c10.65,23.78,15.82,64.62,35.52,81.82,52.41,45.74,144.35,60.43,173.29,83.06h0a491.11,491.11,0,0,1-51.9-49.31c-52.11-58.12-155.14-153.88-210.79-177.18C711.46,2073.32,735.13,2101.18,745.79,2125Z",
    className: "color6fc183 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 3.31,
    d: "M708.48,2095.7c22.21,23.65,41.75,100.18,80.83,144.83s51.51,52.94,97.69,82.33,127,97,148.33,148Z",
    className: "colorStroke292929 svgStroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#419786",
    d: "M1053.09,1833.67s22.2,47.49,30.2,117c7.41,64.44-3.55,77.48,10.66,150.58s27.23,94,42,179.28,25.46,190.3,25.46,190.3h139.82s-10.75-28.14-12.23-97.48,9.57-159.08-14.6-245.37S1188.09,1880.4,1053.09,1833.67Z",
    className: "color419786 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 3.31,
    d: "M1097.5,1878.89s74.6,71.74,90.59,178.33,1.78,306.1,16,359.86Z",
    className: "colorStroke292929 svgStroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#6fc183",
    d: "M751.12,1857.91s66.31,22,110.13,27,97.1,10.06,124.34,36.19,27.24,89.44,63.95,109.54,100.66,83.74,122,134.84,34.34,149.58,35.53,188.78,23.68,98.49,34.34,116.58H1104s-99.47-84.42-125.53-150.75-18.94-137.69-46.18-176.88-75.57-91.75-113.68-138.76C766.51,1940.2,751.12,1857.91,751.12,1857.91Z",
    className: "color6fc183 svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#419786",
    d: "M932.3,2143.22c6.47,9.3,11,20.47,14.46,32.91l0,0c-9.77-90.22-27.54-142.6-60.69-171.69s-124.35-104.22-135-146.55c0,0,15.39,82.29,67.5,146.55C856.73,2051.47,905.06,2104,932.3,2143.22Z",
    className: "color419786 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 3.31,
    d: "M796.12,1890c45,35.18,99.47,58.09,137.36,98.39s88.45,122.92,119.61,180.13c56.6,103.9,98.29,254.14,135,302.38Z",
    className: "colorStroke292929 svgStroke"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3272.95,
    cy: 2648.27,
    fill: "#7a8db0",
    rx: 658.57,
    ry: 89.56,
    className: "color7a8db0 svgShape"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2340.14,
    cy: 2496.16,
    fill: "#7a8db0",
    rx: 1440.22,
    ry: 99.38,
    className: "color7a8db0 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 453.88,
    height: 286.66,
    x: 2033.15,
    y: 2039.98,
    fill: "#7a8db0",
    className: "color7a8db0 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 453.88,
    height: 286.66,
    x: 1965.33,
    y: 2039.98,
    fill: "#99b1da",
    className: "color99b1da svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a8db0",
    d: "M2743.35,2412.64H1822.06a86.11,86.11,0,0,1,86.11-86.11h749.07a86.11,86.11,0,0,1,86.11,86.11Z",
    className: "color7a8db0 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#93a9c9",
    d: "M2682.42,2412.64H1761.13a86.11,86.11,0,0,1,86.11-86.11h749.07a86.11,86.11,0,0,1,86.11,86.11Z",
    className: "color93a9c9 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 521.7,
    height: 40.21,
    x: 1965.33,
    y: 2122.64,
    fill: "#5f6468",
    opacity: 0.39,
    className: "color5f6468 svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2215.03,
    height: 1523.82,
    x: 1167.06,
    y: 600.05,
    fill: "#1d2f59",
    rx: 62.63,
    className: "color1d2f59 svgShape"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2215.03,
    height: 1523.82,
    x: 1109.56,
    y: 600.05,
    fill: "#d1dbed",
    rx: 62.63,
    className: "colord1dbed svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a8db0",
    d: "M1172.7,1888.24V736a80.53,80.53,0,0,1,80.45-80.44H3189.28A80.52,80.52,0,0,1,3269.72,736V1888.24Z",
    className: "color7a8db0 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#edf6fc",
    d: "M3240.1,736v1122.6H1202.32V736a50.82,50.82,0,0,1,50.82-50.82H3189.28A50.83,50.83,0,0,1,3240.1,736Z",
    className: "coloredf6fc svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 7.04,
    d: "M2260.33,1985.08a54.9,54.9,0,1,1-54.9-54.9A54.9,54.9,0,0,1,2260.33,1985.08Z",
    className: "colorStrokefff svgStroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1955.42 685.19C1745.9 882.37 1449 1161.3 1202.32 1392.9V736a50.82 50.82 0 0150.82-50.82zM3240.1 736V1320.7l-443.28 537.91h-1111c200.71-233.87 715.76-833.5 1011.56-1173.42h491.94A50.83 50.83 0 013240.1 736z",
    className: "colorfff svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#99b1da",
    points: "3556.13 699.08 935.52 699.08 1137.8 526.88 3345.65 526.88 3556.13 699.08",
    className: "color99b1da svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1506.34 526.88 1338.69 699.1 1137.1 699.1 1320.15 526.88 1506.34 526.88",
    className: "colorfff svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1863.08 526.88 1741.86 699.1 1540.27 699.1 1684.35 526.88 1863.08 526.88",
    className: "colorfff svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "2165.94 526.88 2145.03 699.1 1943.45 699.1 2007.74 526.88 2165.94 526.88",
    className: "colorfff svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "3152.96 699.1 2978.98 526.88 3165.17 526.88 3354.55 699.1 3152.96 699.1",
    className: "colorfff svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "2749.79 699.1 2642.26 526.88 2806.3 526.88 2951.38 699.1 2749.79 699.1",
    className: "colorfff svgShape"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "2346.62 699.1 2317.05 526.88 2475.33 526.88 2548.2 699.1 2346.62 699.1",
    className: "colorfff svgShape"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M1036.31,801.12h0A100.78,100.78,0,0,1,935.52,700.33V699.1H1137.1v1.23A100.78,100.78,0,0,1,1036.31,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M1036.31,801.12h0A100.78,100.78,0,0,1,935.52,700.33V699.1H1137.1v1.23A100.78,100.78,0,0,1,1036.31,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M1237.9,801.12h0a100.79,100.79,0,0,1-100.8-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,1237.9,801.12Z",
    className: "colord1dbed svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M1439.48,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1h201.58v1.23A100.78,100.78,0,0,1,1439.48,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M1439.48,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1h201.58v1.23A100.78,100.78,0,0,1,1439.48,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M1641.07,801.12h0a100.79,100.79,0,0,1-100.8-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,1641.07,801.12Z",
    className: "colord1dbed svgShape"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M1842.65,801.12h0a100.79,100.79,0,0,1-100.79-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,1842.65,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M1842.65,801.12h0a100.79,100.79,0,0,1-100.79-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,1842.65,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M2044.24,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1H2145v1.23A100.78,100.78,0,0,1,2044.24,801.12Z",
    className: "colord1dbed svgShape"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M2245.82,801.12h0A100.79,100.79,0,0,1,2145,700.33V699.1h201.59v1.23A100.79,100.79,0,0,1,2245.82,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M2245.82,801.12h0A100.79,100.79,0,0,1,2145,700.33V699.1h201.59v1.23A100.79,100.79,0,0,1,2245.82,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M2447.41,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1H2548.2v1.23A100.78,100.78,0,0,1,2447.41,801.12Z",
    className: "colord1dbed svgShape"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M2649,801.12h0a100.79,100.79,0,0,1-100.8-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,2649,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M2649,801.12h0a100.79,100.79,0,0,1-100.8-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,2649,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M2850.58,801.12h0a100.79,100.79,0,0,1-100.79-100.79V699.1h201.59v1.23A100.79,100.79,0,0,1,2850.58,801.12Z",
    className: "colord1dbed svgShape"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M3052.17,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1H3153v1.23A100.79,100.79,0,0,1,3052.17,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M3052.17,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1H3153v1.23A100.79,100.79,0,0,1,3052.17,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M3253.75,801.12h0A100.79,100.79,0,0,1,3153,700.33V699.1h201.59v1.23A100.79,100.79,0,0,1,3253.75,801.12Z",
    className: "colord1dbed svgShape"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M3455.34,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1h201.58v1.23A100.78,100.78,0,0,1,3455.34,801.12Z",
    className: "colorc3c3c3 svgShape"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#8aa0bf",
    d: "M3455.34,801.12h0a100.78,100.78,0,0,1-100.79-100.79V699.1h201.58v1.23A100.78,100.78,0,0,1,3455.34,801.12Z",
    className: "color8aa0bf svgShape"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M3542.83,758.05l.36.66a.82.82,0,0,1-.36-.3c-.15-.12-.43-.24-.58-.36Z",
    className: "colorc3c3c3 svgShape"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f4171",
    d: "M2614.16,1217.07h-679.9a8.6,8.6,0,0,1-8.45-7l-25-131.15a8.52,8.52,0,0,0-1.33-3.17V1072H1696.32v29h179.43l23.75,130.62,2.64,14.51,47.35,260.43,10.3,56.66,25.5,140.25a8.59,8.59,0,0,0,8.46,7.06h506.39a8.6,8.6,0,0,0,8.6-8.6v-11.83a8.6,8.6,0,0,0-8.6-8.6H2022.71a8.58,8.58,0,0,1-8.44-7L2001,1604.6a8.59,8.59,0,0,1,8.44-10.2h516.5a8.61,8.61,0,0,0,8.35-6.55l5.5-22.48,21.35-87.07,7.11-29,21.34-87.07,6.55-26.7,26.41-107.78A8.6,8.6,0,0,0,2614.16,1217.07Zm-247.08,105.46,17.12-69.88a8.6,8.6,0,0,1,8.35-6.55h74.21a8.59,8.59,0,0,1,8.35,10.64L2458,1326.62a8.59,8.59,0,0,1-8.35,6.55h-74.21A8.59,8.59,0,0,1,2367.08,1322.53Zm-116.1,0,17.12-69.88a8.6,8.6,0,0,1,8.35-6.55h74.21a8.59,8.59,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55h-74.2A8.59,8.59,0,0,1,2251,1322.53Zm-116.1,0,17.12-69.88a8.6,8.6,0,0,1,8.35-6.55h74.21a8.59,8.59,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.34,6.55h-74.21A8.59,8.59,0,0,1,2134.88,1322.53Zm-116.1,0,17.12-69.88a8.6,8.6,0,0,1,8.35-6.55h74.21a8.59,8.59,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.34,6.55h-74.21A8.59,8.59,0,0,1,2018.78,1322.53Zm-70.86,3.65-13.31-69.88a8.6,8.6,0,0,1,8.45-10.2h59.3a8.59,8.59,0,0,1,8.35,10.64l-17.12,69.88a8.6,8.6,0,0,1-8.35,6.55h-28.87A8.6,8.6,0,0,1,1947.92,1326.18Zm12.63,66.28-3.82-20.06a8.59,8.59,0,0,1,8.44-10.2h8.74a8.6,8.6,0,0,1,8.35,10.64l-4.92,20.05C1975.14,1401.86,1962.28,1401.53,1960.55,1392.46Zm109.35,96.48-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55H2000.6a8.6,8.6,0,0,1-8.45-7l-13.28-69.75a8.69,8.69,0,0,1,.09-3.66l0-.12a8.59,8.59,0,0,1,8.35-6.55h74.21A8.59,8.59,0,0,1,2069.9,1488.94Zm-71.23-39.67a8.59,8.59,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55H2090a8.6,8.6,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55ZM2186,1488.94l-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55h-74.21a8.6,8.6,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21A8.59,8.59,0,0,1,2186,1488.94Zm-71.23-39.67a8.59,8.59,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21a8.6,8.6,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55Zm187.33,39.67L2285,1558.82a8.59,8.59,0,0,1-8.35,6.55h-74.21a8.6,8.6,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21A8.59,8.59,0,0,1,2302.1,1488.94Zm-71.23-39.67a8.59,8.59,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21a8.6,8.6,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55Zm187.33,39.67-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55h-74.21a8.6,8.6,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21A8.59,8.59,0,0,1,2418.2,1488.94ZM2347,1449.27a8.59,8.59,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21a8.6,8.6,0,0,1,8.35,10.64l-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55Zm187.33,39.67-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55h-74.21a8.6,8.6,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55H2526A8.59,8.59,0,0,1,2534.3,1488.94Zm28.46-116.1-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55h-74.21a8.59,8.59,0,0,1-8.35-10.64l17.13-69.88a8.59,8.59,0,0,1,8.35-6.55h74.21A8.6,8.6,0,0,1,2562.76,1372.84Zm28.45-116.1-17.13,69.88a8.59,8.59,0,0,1-8.35,6.55h-74.21a8.6,8.6,0,0,1-8.35-10.64l17.13-69.88a8.6,8.6,0,0,1,8.35-6.55h74.21A8.59,8.59,0,0,1,2591.21,1256.74Z",
    className: "color2f4171 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2427.26,
    cy: 1758.87,
    r: 58.05,
    fill: "#99b1da",
    transform: "rotate(-80.78 2427.359 1758.867)",
    className: "color99b1da svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2070.42,
    cy: 1758.87,
    r: 58.05,
    fill: "#99b1da",
    transform: "rotate(-80.78 2070.516 1758.87)",
    className: "color99b1da svgShape"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1973.91 1362.2h-8.74a8.59 8.59 0 00-8.44 10.2l3.82 20.06c1.73 9.07 14.59 9.4 16.79.43l4.92-20.05A8.6 8.6 0 001973.91 1362.2zM1993.59 1326.62l17.12-69.88a8.59 8.59 0 00-8.35-10.64h-59.3a8.6 8.6 0 00-8.45 10.2l13.31 69.88a8.6 8.6 0 008.45 7h28.87A8.6 8.6 0 001993.59 1326.62zM2061.55 1478.3h-74.21a8.59 8.59 0 00-8.35 6.55l0 .12a8.69 8.69 0 00-.09 3.66l13.28 69.75a8.6 8.6 0 008.45 7h43.82a8.59 8.59 0 008.35-6.55l17.13-69.88A8.59 8.59 0 002061.55 1478.3zM2081.23 1442.72l17.13-69.88a8.6 8.6 0 00-8.35-10.64H2015.8a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.59 8.59 0 008.35 10.64h74.21A8.59 8.59 0 002081.23 1442.72zM2259.33 1333.17h74.2a8.59 8.59 0 008.35-6.55l17.13-69.88a8.59 8.59 0 00-8.35-10.64h-74.21a8.6 8.6 0 00-8.35 6.55L2251 1322.53A8.59 8.59 0 002259.33 1333.17zM2375.42 1333.17h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88a8.59 8.59 0 00-8.35-10.64h-74.21a8.6 8.6 0 00-8.35 6.55l-17.12 69.88A8.59 8.59 0 002375.42 1333.17zM2027.13 1333.17h74.21a8.59 8.59 0 008.34-6.55l17.13-69.88a8.59 8.59 0 00-8.35-10.64h-74.21a8.6 8.6 0 00-8.35 6.55l-17.12 69.88A8.59 8.59 0 002027.13 1333.17zM2177.65 1478.3h-74.21a8.59 8.59 0 00-8.35 6.55L2078 1554.73a8.6 8.6 0 008.35 10.64h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88A8.59 8.59 0 002177.65 1478.3zM2143.23 1333.17h74.21a8.59 8.59 0 008.34-6.55l17.13-69.88a8.59 8.59 0 00-8.35-10.64h-74.21a8.6 8.6 0 00-8.35 6.55l-17.12 69.88A8.59 8.59 0 002143.23 1333.17zM2429.53 1442.72l17.13-69.88a8.6 8.6 0 00-8.35-10.64H2364.1a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.59 8.59 0 008.35 10.64h74.21A8.59 8.59 0 002429.53 1442.72zM2582.86 1246.1h-74.21a8.6 8.6 0 00-8.35 6.55l-17.13 69.88a8.6 8.6 0 008.35 10.64h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88A8.59 8.59 0 002582.86 1246.1zM2197.33 1442.72l17.13-69.88a8.6 8.6 0 00-8.35-10.64H2131.9a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.59 8.59 0 008.35 10.64H2189A8.59 8.59 0 002197.33 1442.72zM2526 1478.3h-74.21a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.6 8.6 0 008.35 10.64h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88A8.59 8.59 0 002526 1478.3zM2554.41 1362.2H2480.2a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.59 8.59 0 008.35 10.64h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88A8.6 8.6 0 002554.41 1362.2zM2293.75 1478.3h-74.21a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.6 8.6 0 008.35 10.64h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88A8.59 8.59 0 002293.75 1478.3zM2313.43 1442.72l17.13-69.88a8.6 8.6 0 00-8.35-10.64H2248a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.59 8.59 0 008.35 10.64h74.21A8.59 8.59 0 002313.43 1442.72zM2409.85 1478.3h-74.21a8.59 8.59 0 00-8.35 6.55l-17.13 69.88a8.6 8.6 0 008.35 10.64h74.21a8.59 8.59 0 008.35-6.55l17.13-69.88A8.59 8.59 0 002409.85 1478.3z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2070.14,
    cy: 1758.87,
    r: 37.23,
    fill: "#1d2f59",
    transform: "rotate(-45 2070.138 1758.87)",
    className: "color1d2f59 svgShape"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2426.12,
    cy: 1758.87,
    r: 37.23,
    fill: "#1d2f59",
    transform: "rotate(-80.78 2426.22 1758.86)",
    className: "color1d2f59 svgShape"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1dbed",
    d: "M1696.32,1057.44h87.08a29,29,0,0,1,29,29v0a29,29,0,0,1-29,29h-87.07a29,29,0,0,1-29-29v0A29,29,0,0,1,1696.32,1057.44Z",
    className: "colord1dbed svgShape"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fa2d6",
    d: "M3709.84,914.07a68.91,68.91,0,0,0,2-14.45,66.87,66.87,0,0,0-33.6-60.11,68.05,68.05,0,0,0-17.66-7.07c-1.06-.26-2.09-.49-3.14-.69a67.14,67.14,0,1,0,22,123.53A66.25,66.25,0,0,0,3709.84,914.07Zm168.52-261.52a123.41,123.41,0,0,0-3.34-71.06,144.59,144.59,0,0,0-29.54-49.13c-23.66-26.39-57.14-46.39-95.12-55.78a218.55,218.55,0,0,0-25.79-4.78,167.91,167.91,0,0,0-51.88,1.36h0a143.28,143.28,0,0,0-62.4,28.52,48.77,48.77,0,0,0,60.28,76.69c10.48-8.19,23.44-14.11,38.61-14.61a67.92,67.92,0,0,1,18.52,2c25.62,6.32,41.32,30.74,34.57,58.07-9.54,38.59-39.93,34.57-77.66,46q-2.68.81-5.4,1.72c-29.69,10.17-35.89,30.38-42.07,55.42l-3.71,14.93a48.54,48.54,0,0,0,34.21,58.43c.41.11.84.23,1.27.33a48.57,48.57,0,0,0,49.93-17.16,47,47,0,0,0,6.84-12.14c3.46-9.1,8-17.65,13.79-23.14v0c4.2-4,9.07-6.4,14.73-6.18,27.58-4.49,53-11.9,73.79-24C3852.7,703.76,3870.87,682.86,3878.36,652.55Z",
    className: "color7fa2d6 svgShape"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#425c96",
    d: "M3663.38 767.82c12.84 15.31 36 24.48 55.45 15.7a48.57 48.57 0 01-49.93 17.16c-.43-.1-.86-.22-1.27-.33a48.54 48.54 0 01-34.21-58.43l3.71-14.93c6.18-25 12.38-45.25 42.07-55.42q2.72-.92 5.4-1.72c37.73-11.42 68.12-7.4 77.66-46 6.75-27.33-9-51.75-34.57-58.07a67.92 67.92 0 00-18.52-2c-15.17.5-28.13 6.42-38.61 14.61a48.76 48.76 0 01-78.7-40.9c13 9.23 33.12 21.11 56.11 11.84 61.67-24.85 123.76-23.74 145.36 40.56s-36.75 98.22-100.69 104.69C3661.2 697.74 3656 759 3663.38 767.82zM3679.38 955.28a67.17 67.17 0 11-22-123.53c1.05.2 2.08.43 3.14.69a68.05 68.05 0 0117.66 7.07c-22.42-2.59-62-1-71.48 39.38-13.45 57.28 52.17 72.32 79.8 37 10.4-13.28 19-17.48 25.28-16.26a68.91 68.91 0 01-2 14.45A66.25 66.25 0 013679.38 955.28z",
    opacity: 0.36,
    className: "color425c96 svgShape"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3140.58,1116c80,69.68,341.4,43.08,341.4,43.08l-17.49-33.22,27.05,22.12,22.43-11.63s-51.63-33.77-40.37-82.32-21.41-65.2-50.38-94.34-13.71-18.35-3.06-107.13c8.37-69.67-27.66-91.27-43.56-97.34a59.08,59.08,0,0,1-16.43-9.8h0c-30-16.05-61-33-117.39,5.72-30.4,20.89-41.59,48.3-41.08,63.87l-48.06,167.12Z",
    fill: "#000000",
    className: "color000 svgShape"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3352.57,722.64a33.64,33.64,0,1,1,22,42.19A33.64,33.64,0,0,1,3352.57,722.64Z",
    fill: "#000000",
    className: "color000 svgShape"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3199.91,1008.26c-21.43,27-31.33,157.32-31.33,157.32-.45,2-.38,10.9-.34,23.72,4.47,25.64,5.65,47.53,4.65,66.17-4.17,77.34-45.9,98.63-45.9,98.63-39.93,28.17-187-196.75-187-196.75-14-10.1-43.46-51-42.35-54.81s7.71-7.71,9.36-14.33,4.41-9.91,9.37-12.12a13.06,13.06,0,0,0,6.61-6.62l51.25,35.83s123.71,96.51,124.46,93.36c18-76.1,44.25-215.47,109.68-199.12C3209.36,999.78,3202.26,1005.29,3199.91,1008.26Z",
    className: "colorf4aea2 svgShape"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M2985.38,1135.29s5.59-46.22-34.63-66.82-68-20-71.28-17.41,16.2,21.65,38.11,28.29c0,0-19.09,8.07-49.93-3.11s-41.31-27-50.73-24.39,10.85,32.23,58.42,46.82c0,0-23.19.38-46.52-7.61s-24.88,8.25-7.28,15.49c0,0-8.63,2-6.9,10.47s17.14,8.7,17.14,8.7-7.2,3.9-2.36,11.48,36.54,10.54,65.77,10.58,57.13-6.34,57.13-6.34Z",
    className: "colorf4aea2 svgShape"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#8e8e8e",
    d: "M2946.06 1114.41l-.3 0c-32.92-7.27-31.77-29.17-31.76-29.39a1.41 1.41 0 012.81.19c0 .82-.88 19.73 29.55 26.45a1.41 1.41 0 01-.3 2.78zM2871.19 1114.24c-25 0-49.75-6.3-50-6.37a1.39 1.39 0 01-1-1.71 1.41 1.41 0 011.71-1c.26.07 26 6.62 51.36 6.26a1.41 1.41 0 01.05 2.81zM2872.52 1130.6c-25 0-40.9-3.5-41.08-3.54a1.41 1.41 0 11.61-2.75c.21 0 20.78 4.56 51.86 3.23a1.41 1.41 0 01.12 2.81Q2878 1130.61 2872.52 1130.6z",
    className: "color8e8e8e svgShape"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#f18d98",
    d: "M3199.91,1008.26c-21.43,27-31.33,157.32-31.33,157.32-.45,2-.38,10.9-.34,23.72,4.47,25.64,5.65,47.53,4.65,66.17-6.21,5.79-10,9.18-10,9.18l-64.14-66c18-76.1,44.25-215.47,109.68-199.12C3209.36,999.78,3202.26,1005.29,3199.91,1008.26Z",
    className: "colorf18d98 svgShape"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#49a380",
    d: "M3208.41,999.54l-42.55,186.1-80.9-48.23s1.63-3.68,4.47-9.86c13.32-29,53.31-112.85,77.18-128,10.2-6.49,18.41-8.4,24.77-8.14C3203,991.85,3208.41,999.54,3208.41,999.54Z",
    className: "color49a380 svgShape"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ec88d",
    d: "M3208.41,999.54l-42.55,186.1-59.34-35.38s40.17-91.31,84.52-130.1C3202.68,1020.61,3208.41,999.54,3208.41,999.54Z",
    className: "color6ec88d svgShape"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3212.21,1016.93c-1.1,60.42,121.48.15,121.48.15s-36.76-21.4-24.61-68.2c3.2-12.41,5.73-23.35,8.67-31.87h-97.18C3218.42,945.78,3212.21,1016.93,3212.21,1016.93Z",
    className: "colorf4aea2 svgShape"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#f18d98",
    d: "M3218,942.76s62.21-1.75,79.88-2.89S3199.86,1048.76,3218,942.76Z",
    className: "colorf18d98 svgShape"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3314 2522l-13.55 96.19s-21.72 63.79-41.9 39.1-40.14-37.75-40.14-37.75l-6.62-100zM3534.44 2524.34l29.93 96s22.79 20 31 19.46c15-.94 22.8-26.75 22.8-26.75l2.47-88.67z",
    className: "colorf4aea2 svgShape"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#293651",
    d: "M3211.79 2619l-80.56 65.3c-4.12 3.06-1.18 8.22 4.71 8.27l118.92 1c2.87 0 5.43-1.28 6.39-3.24l9-18.39c2.59-5.31 7.75-5.74 7.28-.11l4.39 17.75c-.24 2.8 28.19 2 28.44-.51 1.56-15.79-1.72-67.41-4.55-81.78-.41-2.06-2.52-3.71-5.33-4.12h0a8 8 0 00-6.64 1.83c-8 7.76-33.7 31.13-47.38 26.4-9.16-3.17-21-8.85-24.74-12.11C3219.17 2617 3214.54 2617 3211.79 2619zM3619.29 2609.68l45.75 76.63c4.88 7.45 2.16 16.34-6.66 21.6-14.31 8.51-26 25.49-35 25.74-16.26.45-41.54-16.67-56.27-23.1-9.89-4.31-17.64-10.62-16.41-18.89l11.37-76.86c.14-1 1.82-1.3 2.64-.55l17.52 15.88c5.74 5.2 21.31 4.5 25.18-1.73 2.76-4.44 9.23-18.78 9.23-18.78A1.81 1.81 0 013619.29 2609.68z",
    className: "color293651 svgShape"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e4ea4",
    d: "M3394.44,1327.89c34.71,61.37,53.06,106.32,73,184.34,23.13,90.49,237.07,855.89,248,1020.48-28.51,6.88-249.59,5.88-267.61,4.87-57.32-164.26-134.2-697.75-158.78-801.24-3.77-15.9-28.35-12.41-26.44,3.83,14,118.17,99.59,615.92,137.06,797.71-15,7.61-242.54,5.92-259.81,3.75-18.78-202.69-118.47-970,32-1218.73C3240.68,1313.41,3324.66,1325.81,3394.44,1327.89Z",
    className: "color2e4ea4 svgShape"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.68,
    d: "M3186.23 1332.9s-66.67 168.63-66.67 382.72 74.83 819 74.83 819zM3670.49 2531.31l-310-1188.45zM3317.59 1348.85s2.08 196.09 90.09 180.63z",
    className: "colorStrokefff svgStroke"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.68,
    d: "M3134.94,1538.48c88,15.46,75.75-194.17,75.75-194.17Z",
    className: "colorStrokefff svgStroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3170.47,1334.53l285.72,232.65s1.58-149-48.75-243.52Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#2d4179",
    opacity: 0.21,
    className: "color2d4179 svgShape"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ec88d",
    d: "M3422.64,1377.42c-34.82,5.48-65.94,9-93.6,11.08-52.79,4-93,2.64-122.51-.44-46.25-4.86-66-14.06-66-14.06,2.55-7.23-3-125-5.44-173-2.4-47.65,53.89-188,51.88-192.82,77.67,32.26,152.07,1.76,152.07,1.76,5,.37,12,2.32,19.36,4.92,18.07,6.37,38.48,16.59,38.48,16.59.15.42.31.85.46,1.29C3418.57,1093.68,3447.74,1284.3,3422.64,1377.42Z",
    className: "color6ec88d svgShape"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#49a380",
    d: "M3422.64,1377.42c-34.82,5.48-65.94,9-93.6,11.08,21.28-73.68,39.27-150.7,46.27-175.16,16.39-57.27-11.68-139.39-16.86-198.47,18.07,6.37,38.48,16.59,38.48,16.59.15.42.31.85.46,1.29C3418.57,1093.68,3447.74,1284.3,3422.64,1377.42Z",
    className: "color49a380 svgShape"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M3216.78 969.59s-8.67 30.77 7.71 43.36l-22.81 65.91c-1.63 5.08-5.3 4.83-5.86 2.2-3.56-16.8-10.17-53.3-5.7-75.19zM3205.82 1084.36c0 4.93 2.13 8.93 4.76 8.93s4.76-4 4.76-8.93-2.13-8.92-4.76-8.92S3205.82 1079.44 3205.82 1084.36zM3203.45 1122.42c0 4.93 2.12 8.93 4.75 8.93s4.76-4 4.76-8.93-2.13-8.92-4.76-8.92S3203.45 1117.5 3203.45 1122.42z",
    className: "colorfff svgShape"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3566.72,1141.6l-11.85,49.25c-23.28,3-53.73-4.32-80.34-13.55-27.83-9.66-51.44-21.48-58.21-26-61.58-41.16-100.27-117.5-83.4-136.57,20.93-23.65,109.76,35.18,139.28,58,14.91,11.5,31,22.72,46.53,33.64C3536.07,1118.47,3552.81,1130.24,3566.72,1141.6Z",
    className: "colorf4aea2 svgShape"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#f18d98",
    d: "M3539.57,1126.27c-10.38,17.45-54.53,37.83-76,47-27.84-9.66-40.49-17.49-47.26-22-61.58-41.16-100.27-117.5-83.4-136.57,20.93-23.65,109.76,35.18,139.28,58C3487.11,1084.18,3524,1115.35,3539.57,1126.27Z",
    className: "colorf18d98 svgShape"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M3340.61,831.42l.37-3.16c-32.44-3.76-60.38-21.49-72.9-46.26-14.69-29.08-2.17-55.12,2-62.41l-2.76-1.59c-4.39,7.64-17.5,34.93-2.09,65.43C3278.24,809.15,3307.12,827.54,3340.61,831.42Z",
    className: "color333 svgShape"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3316.49,723.48c-59.16-16.33-99.64,15.14-114.61,69.38,0,0-5.53,38.12-6.18,41-.08.37-28.7,59.14,17.51,118.75,2.61,3.37,6.81,4.76,11.07,5.89,88.57,23.49,101.29-64.82,101.29-64.82,1.91-4.27,43.54-44.46,44.82-49.09C3385.35,790.33,3375.64,739.8,3316.49,723.48Z",
    className: "colorf4aea2 svgShape"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3237,757.47,3233.76,796s73.23,13.9,103.92,26.13c0,0-23.95,54.16-8.62,61.37,0,0,62.19,2.87,56.4-76.17s-66.55-92.2-109.37-89.3-88.63,30.78-92.82,73.14l34.68,5S3226,768.81,3237,757.47Z",
    fill: "#000000",
    className: "color000 svgShape"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M3272.4 814.79c4.59-3.79 24.22 7.49 25 8.08 6 4.51 3.22 8.6 2.12 9.94-.64.77-2.88-.79-8.63-3-12.26-4.63-17.89-3.48-19.79-7.65C3270 819.73 3270.57 816.3 3272.4 814.79zM3229.72 809.45c-2.33-4.32-19.66-1.23-20.45-1-6 1.59-6.25 5-5.82 6.37.25.79 2.44.29 7.5.42 10.78.26 14.72 2.88 17.46.29C3230 814 3230.65 811.17 3229.72 809.45z",
    className: "color333 svgShape"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M3230.49,877.46c-.32-.15-7.77-3.72-8.51-10.68-.57-5.34,3-10.95,10.54-16.68l2,2.59c-6.49,4.92-9.7,9.66-9.28,13.73.54,5.14,6.61,8.07,6.67,8.1Z",
    className: "color2b2b2b svgShape"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3370.76,894.54c-5.59,17.43-22.9,27.47-38.64,22.42s-24-23.29-18.39-40.72,22.9-27.47,38.64-22.42S3376.35,877.1,3370.76,894.54Z",
    className: "colorf4aea2 svgShape"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M3344.53,895.47c-1.67-4.66-10.13-7-13.24-7.44l-2.06-.32.81-1.92c3.17-7.46,7.47-12.11,12.79-13.81a16.4,16.4,0,0,1,12.73,1.44l-1.69,2.77a13.47,13.47,0,0,0-10.09-1.11c-3.94,1.28-7.27,4.7-9.93,10.17,3.81.91,11.7,3.44,13.74,9.12Z",
    className: "color2b2b2b svgShape"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#f18d98",
    d: "M3326.18 893.82a168 168 0 002.77-29.1 37.59 37.59 0 00-20.67 70.91C3322.91 916.35 3326.18 893.82 3326.18 893.82zM3191.41 845.88a117.66 117.66 0 00-.88 61.32 37.56 37.56 0 00.88-61.32z",
    className: "colorf18d98 svgShape"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M3283.71 850.51c-1.15 3.87-3.91 6.47-6.16 5.8s-3.16-4.35-2-8.22 3.91-6.47 6.17-5.8S3284.86 846.64 3283.71 850.51zM3217.19 839.38c-1.05 3.53-3.57 5.89-5.62 5.28s-2.87-4-1.83-7.49 3.56-5.89 5.62-5.28S3218.23 835.85 3217.19 839.38z",
    className: "color2b2b2b svgShape"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M3287.53,726c-2.16-.69,24.83.54,48.28,12.84,30,15.74,45.16,45,43.05,47.06-1.63,1.56-15.36-11.26-18.19-8.62-2,1.81,3.08,9.24,1.63,10.32-2.61,1.95-21.23-20.57-24.83-18.11-1.58,1.08,1.22,6-.35,7.18-3,2.22-15-13.56-33.93-25.86-17.27-11.25-31.73-14.07-31.31-15.45.77-2.55,48.73,10.49,49.37,8.32C3321.81,741.78,3308.38,732.57,3287.53,726Z",
    className: "color292929 svgShape"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M3249.7,915.44a2.2,2.2,0,0,1-1.83-1c-4.95-7.47-10.77-11.9-17.31-13.17-9.28-1.8-17,3.45-17.11,3.5a2.2,2.2,0,0,1-2.5-3.61c.37-.26,9.27-6.33,20.38-4.21,7.77,1.48,14.56,6.55,20.2,15.06a2.19,2.19,0,0,1-.62,3A2.15,2.15,0,0,1,3249.7,915.44Z",
    className: "color2b2b2b svgShape"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ec88d",
    d: "M3351.32,1002.09s-29.27,1.3-29.27,34.48-3.3,41.33,17.54,76.93,105.6,78,105.6,78l30.63-116.07S3418.33,1005.34,3351.32,1002.09Z",
    className: "color6ec88d svgShape"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M3339.59,1009.73l-29.1-38.06s-34.67,24.64-86.72,42.83l.64,67.14a2.68,2.68,0,0,0,3.91,2.12C3244.86,1075.26,3317.69,1042.12,3339.59,1009.73Z",
    className: "colorfff svgShape"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3484.52,924.42c4-23.1,13.55-49.24,12.44-65-1-14.23-23.74-51.71-34.11-56.53-12.41-5.78-56.35,8.61-53,17.5,1.79,4.78,7.57,6.7,12.45,5.8s26.26-3,29.1-2.84c3.2.23,6.93,5.39,11.37,17.61-18.73-7-25.84-11.28-35.15-7.21-5.58,2.45-8.53,9.22-5.71,16.92-3.1-2-9.9-.12-12.38,2.56-5.27,5.73-4.81,11.88-1.64,18.92-12.45-1.74-9.13,10.89-6.84,20.33a126.66,126.66,0,0,0,9.87,27.38c2.68,5.3,7.76,8.22,11.11,5.45,5.09-4.16,2-17.59.32-25.94,2.13,0,8.42,2.25,10,5.07-7.13,14.19-9,36.22,4.08,51.5C3464,957.44,3480.08,950.37,3484.52,924.42Z",
    className: "colorf4aea2 svgShape"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#8e8e8e",
    d: "M3453.22 862.14a1.57 1.57 0 01-.66-.14 140.55 140.55 0 00-28.78-9.08 1.64 1.64 0 01.65-3.22 143.89 143.89 0 0129.46 9.29 1.65 1.65 0 01.84 2.17A1.63 1.63 0 013453.22 862.14zM3436.75 883.34a1.63 1.63 0 01-.82-.22 82 82 0 00-26-9.6 1.65 1.65 0 01.6-3.24 85.81 85.81 0 0127.07 10 1.65 1.65 0 01-.82 3.07z",
    className: "color8e8e8e svgShape"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aea2",
    d: "M3432.87,950.4l81.67,190.25c.28.67.58,1.33.89,2,9.15,21.14,21,44,43,50.32s56.67-3,58.75-37.42c.1-1.37.09-2.78.06-4.21-.67-27.87-23.79-64.79-47.86-91.15-33.16-36.27-67.31-90.94-88.55-135.23C3465.14,931.65,3449.38,938.37,3432.87,950.4Z",
    className: "colorf4aea2 svgShape"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 357.54,
    height: 325.89,
    x: 3632.29,
    y: 1243.76,
    fill: "#99b1da",
    rx: 41.33,
    transform: "rotate(180 3811.06 1406.705)",
    className: "color99b1da svgShape"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#99b1da",
    d: "M3785.53,1554.81,3747.77,1630a9.88,9.88,0,0,1-17.77-.22l-35.17-74.52Z",
    className: "color99b1da svgShape"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3885.95,
    cy: 1400.1,
    r: 21.51,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3811.06,
    cy: 1400.1,
    r: 21.51,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3736.17,
    cy: 1400.1,
    r: 21.51,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 550.13,
    height: 162.2,
    x: 2024.43,
    y: 945.32,
    fill: "#99b1da",
    rx: 26.78,
    className: "color99b1da svgShape"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2f59",
    d: "M2094.77 1051.46h46.74v19.66h-71.64v-89.4h70v19.67h-45.08zm-1.79-35.13h41.51v18.78H2093zM2155.69 1071.12v-89.4h20.82l36.91 60.8h-11l36.15-60.8h20.82l.12 89.4h-23.24l-.26-54h4L2213 1062.31H2201.8l-27.72-45.21h4.85v54zM2277.53 1071.12v-89.4h40.74q12.27 0 21.2 4a30.44 30.44 0 0113.73 11.43 31.78 31.78 0 014.79 17.56q0 10.35-4.79 17.69a31.09 31.09 0 01-13.73 11.37q-8.94 4-21.2 4h-26.82l11.37-11.11v34.48zm25.29-31.54l-11.37-11.88h25.29q7.92 0 11.88-3.38t4-9.65a12.06 12.06 0 00-4-9.51q-4-3.51-11.88-3.51h-25.29L2302.82 990zM2387.11 1071.12v-69.35h-27.46v-20h80.08v20H2412.4v69.35z",
    className: "color1d2f59 svgShape"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2f59",
    d: "M2469.62,1071.12v-37.8l5.87,15.2-40.1-66.8h26.82l28.74,48.41h-15.33l29-48.41h24.52l-39.72,66.8,5.49-15.2v37.8Z",
    className: "color1d2f59 svgShape"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109.55,
    cy: 1565.37,
    r: 240.82,
    fill: "#7a8db0",
    className: "color7a8db0 svgShape"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M1109.55,1381c101.82,0,184.36,82.53,184.36,184.35a184.36,184.36,0,0,1-184.36,184.36c-101.81,0-184.35-82.54-184.35-184.36A184.35,184.35,0,0,1,1109.55,1381Zm0,48a136.36,136.36,0,1,0,136.36,136.36A136.36,136.36,0,0,0,1109.55,1429Z",
    className: "colorfff svgShape"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 44.73,
    height: 304.35,
    x: 1095.37,
    y: 1419.19,
    fill: "#ffffff",
    transform: "rotate(-45 1117.788 1571.407)",
    className: "colorfff svgShape"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1466.21,1933.31c0,10.15,6.79,18.37,15.17,18.37s15.18-8.22,15.18-18.37-6.8-18.38-15.18-18.38S1466.21,1923.17,1466.21,1933.31Z",
    className: "color838383 svgShape"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1481.38 1918.88c6.58 0 11.91 6.45 11.91 14.43h-4.46c0-5-3.35-9-7.45-9s-7.44 4-7.44 9h-4.47C1469.47 1925.33 1474.8 1918.88 1481.38 1918.88zM1481.38 1942.33c4.1 0 7.45-4 7.45-9h4.46c0 8-5.33 14.43-11.91 14.43s-11.91-6.47-11.91-14.43h4.47C1473.94 1938.3 1477.27 1942.33 1481.38 1942.33zM1383.45 1933.31c0 10.15-6.79 18.37-15.17 18.37s-15.16-8.22-15.16-18.37 6.78-18.38 15.16-18.38S1383.45 1923.17 1383.45 1933.31z",
    className: "color838383 svgShape"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1368.28,1918.88c-6.59,0-11.91,6.45-11.91,14.43h4.46c0-5,3.35-9,7.45-9s7.45,4,7.45,9h4.46C1380.19,1925.33,1374.86,1918.88,1368.28,1918.88Z",
    className: "color838383 svgShape"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a471",
    d: "M1424.83,1769.63c62.11,0,63.91,155.92,63.91,173.69H1474c0-43.35-8.83-155.88-49.19-155.88s-49.19,112.53-49.19,155.88h-14.72C1360.92,1925.55,1362.74,1769.63,1424.83,1769.63Z",
    className: "colorf4a471 svgShape"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1368.28,1942.33c-4.1,0-7.45-4-7.45-9h-4.46c0,8,5.32,14.43,11.91,14.43s11.91-6.47,11.91-14.43h-4.46C1375.73,1938.3,1372.4,1942.33,1368.28,1942.33Z",
    className: "color838383 svgShape"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 334.39,
    height: 580.32,
    x: 1326.1,
    y: 1897.78,
    fill: "#facc88",
    className: "colorfacc88 svgShape"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 63.2,
    height: 580.32,
    x: 1283.58,
    y: 1897.78,
    fill: "#f4a471",
    opacity: 0.82,
    className: "colorf4a471 svgShape"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 63.25,
    height: 580.32,
    x: 1220.34,
    y: 1897.78,
    fill: "#facc88",
    className: "colorfacc88 svgShape"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M1534.66,1937.49c0,10.15,6.8,18.37,15.19,18.37s15.17-8.22,15.17-18.37-6.8-18.37-15.17-18.37S1534.66,1927.34,1534.66,1937.49Z",
    className: "color656565 svgShape"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M1549.85,1923.06c6.57,0,11.9,6.46,11.9,14.43h-4.47c0-5-3.34-9-7.43-9s-7.44,4-7.44,9h-4.49C1537.92,1929.52,1543.27,1923.06,1549.85,1923.06Z",
    className: "color656565 svgShape"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a471",
    d: "M1542.49,1947.52h14.7c0-17.79-1.79-173.71-63.91-173.71v17.81C1533.65,1791.62,1542.49,1904.16,1542.49,1947.52Z",
    className: "colorf4a471 svgShape"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M1549.85 1946.51c4.09 0 7.43-4 7.43-9h4.47c0 8-5.33 14.42-11.9 14.42s-11.93-6.46-11.93-14.42h4.49C1542.41 1942.47 1545.72 1946.51 1549.85 1946.51zM1451.91 1937.49c0 10.15-6.78 18.37-15.17 18.37s-15.18-8.22-15.18-18.37 6.8-18.37 15.18-18.37S1451.91 1927.34 1451.91 1937.49z",
    className: "color656565 svgShape"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M1436.74,1923.06c-6.58,0-11.91,6.46-11.91,14.43h4.47c0-5,3.32-9,7.44-9s7.46,4,7.46,9h4.46C1448.66,1929.52,1443.32,1923.06,1436.74,1923.06Z",
    className: "color656565 svgShape"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a471",
    d: "M1444.09,1947.52h-14.7c0-17.79,1.8-173.71,63.89-173.71v17.81C1452.94,1791.62,1444.09,1904.16,1444.09,1947.52Z",
    className: "colorf4a471 svgShape"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M1436.74,1946.51c-4.12,0-7.44-4-7.44-9h-4.47c0,8,5.33,14.42,11.91,14.42s11.92-6.46,11.92-14.42h-4.46C1444.2,1942.47,1440.87,1946.51,1436.74,1946.51Z",
    className: "color656565 svgShape"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1800.15,
    cy: 2105.35,
    fill: "#838383",
    rx: 15.18,
    ry: 18.38,
    className: "color838383 svgShape"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1800.15 2090.93c6.58 0 11.92 6.47 11.92 14.42h-4.47c0-5-3.33-9-7.45-9s-7.45 4-7.45 9h-4.47C1788.23 2097.4 1793.56 2090.93 1800.15 2090.93zM1800.15 2114.37c4.12 0 7.45-4 7.45-9h4.47c0 8-5.34 14.42-11.92 14.42s-11.92-6.44-11.92-14.42h4.47C1792.7 2110.34 1796 2114.37 1800.15 2114.37zM1702.23 2105.35c0 10.16-6.81 18.38-15.18 18.38s-15.18-8.22-15.18-18.38 6.8-18.38 15.18-18.38S1702.23 2095.21 1702.23 2105.35z",
    className: "color838383 svgShape"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1687.05,2090.93c-6.58,0-11.91,6.47-11.91,14.42h4.47c0-5,3.32-9,7.44-9s7.45,4,7.45,9H1699C1699,2097.4,1693.63,2090.93,1687.05,2090.93Z",
    className: "color838383 svgShape"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#d18c66",
    d: "M1743.59,1941.68c62.12,0,63.91,155.92,63.91,173.7h-14.71c0-43.37-8.84-155.89-49.2-155.89s-49.18,112.52-49.18,155.89h-14.72C1679.69,2097.6,1681.48,1941.68,1743.59,1941.68Z",
    className: "colord18c66 svgShape"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1687.05,2114.37c-4.12,0-7.44-4-7.44-9h-4.47c0,8,5.33,14.42,11.91,14.42s11.91-6.44,11.91-14.42h-4.46C1694.5,2110.34,1691.17,2114.37,1687.05,2114.37Z",
    className: "color838383 svgShape"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 334.37,
    height: 408.28,
    x: 1644.88,
    y: 2069.82,
    fill: "#f4a471",
    className: "colorf4a471 svgShape"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 63.22,
    height: 408.28,
    x: 1602.34,
    y: 2069.82,
    fill: "#d18c66",
    className: "colord18c66 svgShape"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 63.21,
    height: 408.28,
    x: 1539.14,
    y: 2069.82,
    fill: "#f4a471",
    className: "colorf4a471 svgShape"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e09773",
    points: "1665.56 2478.1 1602.34 2384.55 1539.13 2478.1 1665.56 2478.1",
    className: "colore09773 svgShape"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1853.44,2109.53c0,10.16,6.79,18.39,15.17,18.39s15.17-8.23,15.17-18.39-6.79-18.37-15.17-18.37S1853.44,2099.38,1853.44,2109.53Z",
    className: "color838383 svgShape"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1868.61,2095.09c6.58,0,11.92,6.48,11.92,14.45h-4.48c0-5-3.32-9-7.44-9s-7.45,4-7.45,9h-4.46C1856.7,2101.57,1862,2095.09,1868.61,2095.09Z",
    className: "color838383 svgShape"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#d18c66",
    d: "M1861.26,2119.55H1876c0-17.77-1.79-173.7-63.9-173.7v17.82C1852.42,1963.67,1861.26,2076.21,1861.26,2119.55Z",
    className: "colord18c66 svgShape"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1868.61 2118.55c4.12 0 7.44-4 7.44-9h4.48c0 8-5.34 14.43-11.92 14.43s-11.91-6.47-11.91-14.43h4.46C1861.16 2114.52 1864.5 2118.55 1868.61 2118.55zM1770.68 2109.53c0 10.16-6.79 18.39-15.17 18.39s-15.17-8.23-15.17-18.39 6.8-18.37 15.17-18.37S1770.68 2099.38 1770.68 2109.53z",
    className: "color838383 svgShape"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1755.51,2095.09c-6.58,0-11.92,6.48-11.92,14.45h4.48c0-5,3.33-9,7.44-9s7.46,4,7.46,9h4.46C1767.43,2101.57,1762.1,2095.09,1755.51,2095.09Z",
    className: "color838383 svgShape"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#d18c66",
    d: "M1762.87,2119.55h-14.72c0-17.77,1.8-173.7,63.92-173.7v17.82C1771.7,1963.67,1762.87,2076.21,1762.87,2119.55Z",
    className: "colord18c66 svgShape"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M1755.51,2118.55c-4.11,0-7.44-4-7.44-9h-4.48c0,8,5.34,14.43,11.92,14.43s11.92-6.47,11.92-14.43H1763C1763,2114.52,1759.63,2118.55,1755.51,2118.55Z",
    className: "color838383 svgShape"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4a471",
    points: "1346.79 2478.1 1283.58 2391.9 1220.34 2478.1 1346.79 2478.1",
    className: "colorf4a471 svgShape"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2600.82,
    cy: 1235.79,
    r: 71.69,
    fill: "#99b1da",
    transform: "rotate(-45 2600.82 1235.785)",
    className: "color99b1da svgShape"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2561.12,1273.24l32.74-45.58-.1,15.08-31.46-44.4h23.86l20,29h-10.06l19.79-29h22.79L2607.35,1242v-15l33.16,46.22h-24.39l-20.44-30.5h9.74l-20.12,30.5Z",
    className: "colorfff svgShape"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1822.06,
    cy: 2283.58,
    r: 100.27,
    fill: "#facc88",
    transform: "rotate(-79.78 1822.243 2283.618)",
    className: "colorfacc88 svgShape"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 151.04,
    height: 46.96,
    x: 1746.54,
    y: 2260.1,
    fill: "#fefefe",
    stroke: "#fefefe",
    strokeMiterlimit: 22.93,
    strokeWidth: 0.87,
    rx: 4.02,
    className: "colorfefefe svgShape colorStrokefefefe svgStroke"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1525.23,
    cy: 692.86,
    r: 234.76,
    fill: "#facc88",
    transform: "rotate(-45 1525.24 692.855)",
    className: "colorfacc88 svgShape"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a471",
    d: "M1628.27,481.63A233.69,233.69,0,0,1,1677.17,604C1689.61,733,1595.07,847.72,1466,860.16a233.6,233.6,0,0,1-125.59-22.73,234.56,234.56,0,0,0,207.31,88.83c129.06-12.44,223.6-127.14,211.16-256.2A234.59,234.59,0,0,0,1628.27,481.63Z",
    opacity: 0.43,
    className: "colorf4a471 svgShape"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1325.69,737c-11.55-119.83,76.22-226.33,196-237.88a217.6,217.6,0,0,1,180.14,68.13,217.86,217.86,0,0,0-198.62-90.69c-119.82,11.55-207.59,118.05-196,237.87a217,217,0,0,0,57.72,127.92A217.07,217.07,0,0,1,1325.69,737Z",
    className: "colorfff svgShape"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1433.51,
    cy: 642.74,
    r: 18.13,
    fill: "#232323",
    transform: "rotate(-81.75 1433.542 642.73)",
    className: "color232323 svgShape"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1605.69,
    cy: 626.14,
    r: 18.13,
    fill: "#232323",
    transform: "rotate(-1.31 1611.675 628.176)",
    className: "color232323 svgShape"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M1463.18,769.54a8,8,0,0,1-7.66-10.36c.55-1.79,14.06-43.95,74.85-49.81,51.47-5,81,31.84,82.21,33.41a8,8,0,1,1-12.58,9.88c-1-1.27-25.54-31.47-68.09-27.36-49.71,4.79-60.66,37.22-61.1,38.6A8,8,0,0,1,1463.18,769.54Z",
    className: "color232323 svgShape"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2749.79,
    cy: 2086.97,
    r: 150.64,
    fill: "#facc88",
    className: "colorfacc88 svgShape"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a471",
    d: "M2854.06,1978a150.67,150.67,0,0,1-245.49,161.18A150.66,150.66,0,1,0,2854.06,1978Z",
    opacity: 0.43,
    className: "colorf4a471 svgShape"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2619.21,2074.92a139.86,139.86,0,0,1,263.1-30.19A139.87,139.87,0,1,0,2622.6,2147,139.27,139.27,0,0,1,2619.21,2074.92Z",
    className: "colorfff svgShape"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2703.53,
    cy: 2038.41,
    r: 11.63,
    fill: "#232323",
    transform: "rotate(-2.25 2698.468 2034.661)",
    className: "color232323 svgShape"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2812.01,
    cy: 2061.93,
    r: 11.63,
    fill: "#232323",
    transform: "rotate(-58.13 2811.702 2061.895)",
    className: "color232323 svgShape"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M2790.17,2141.82a5.14,5.14,0,0,1-4.73-3.12c-.1-.24-11-24.75-37.92-30.6-31.08-6.73-42.68,11-43.16,11.74a5.13,5.13,0,0,1-8.74-5.37c.61-1,15.57-24.75,54.08-16.4,32.28,7,44.68,35.41,45.19,36.61a5.13,5.13,0,0,1-2.72,6.73A5,5,0,0,1,2790.17,2141.82Z",
    className: "color232323 svgShape"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#99b1da",
    d: "M1741.61,1309.83c-1.55-11.15-6.65-18.94-14.34-21.93s-16.71-.7-25.4,6.45l-145.76,120.11c-8.64,7.12-12.66,15.64-11.32,24s7.89,15.28,18.41,19.38l170,66.21c10.53,4.1,20,3.45,26.68-1.83s9.43-14.24,7.88-25.33Z",
    className: "color99b1da svgShape"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1666.89 1442.93a12.15 12.15 0 106.92 15.74A12.16 12.16 0 001666.89 1442.93zM1672 1429.71c4.16 1.62 9.84-2 12.62-8.11l33-72a11.36 11.36 0 00-6.26-15.46l-3.77-1.47a11.35 11.35 0 00-15.07 7.16l-24.36 75.36C1666.17 1421.56 1667.89 1428.09 1672 1429.71z",
    className: "colorfff svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0b4d3d6267b7a26a563e702fa231777f.svg";
export { ForwardRef as ReactComponent };